var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1567_4845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3325 22.2346C20.1646 17.586 17.6904 14.9028 13.5467 14.9028C9.40303 14.9028 6.9289 17.586 6.75977 22.2636V23.8039C8.73014 25.0458 11.0521 25.7755 13.5467 25.7755C16.0414 25.7755 18.3633 25.0458 20.3325 23.8051V22.2346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5469 0.224609C6.50259 0.224609 0.771484 5.95572 0.771484 13C0.771484 16.8187 2.46521 20.2424 5.13022 22.5861V22.2345C5.28364 17.9664 7.24676 14.9752 10.4168 13.8179C9.18814 12.8732 8.38236 11.4041 8.38236 9.7382C8.38236 6.89077 10.6994 4.57368 13.5469 4.57368C16.3943 4.57368 18.7114 6.89077 18.7114 9.7382C18.7114 11.4041 17.9056 12.8719 16.677 13.8167C19.847 14.9728 21.8089 17.9591 21.9623 22.2043V22.5861C24.6285 20.2424 26.3223 16.8187 26.3223 12.9988C26.3223 5.95572 20.5912 0.224609 13.5469 0.224609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0799 9.73821C17.0799 7.78958 15.4949 6.20459 13.5463 6.20459C11.5977 6.20459 10.0127 7.78958 10.0127 9.73821C10.0127 11.6868 11.5977 13.2718 13.5463 13.2718C15.4949 13.2718 17.0799 11.6868 17.0799 9.73821Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1567_4845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5508,
    height: 25.5508,
    fill: "white",
    transform: "translate(0.771484 0.224609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.c3497d5582184a4b39caad34bc2d3c05.svg";
export { ForwardRef as ReactComponent };